<template>
  <div class="wrapper home-page">
    <div class="page-header clear-filter">
      <div>
        <parallax
            class="page-header-image"
            :style="{ backgroundImage: `url(${bgImage})` }"
        />
      </div>
      <div class="rellax-text-container rellax-text">
        <h1
            class="h1-seo font-goodtimes bg-bdigital-blue"
            data-rellax-speed="-2"
        >
          BOIGNER DIGITAL
        </h1>
      </div>
      <h3
          class="h3-description rellax-text text-bdigital-blue shadow-bdigital-blue"
          data-rellax-speed="-1"
      >
        Ihr Partner für individuelle Softwarelösungen.
        <br />
        &nbsp;
        <br />
        Beratung, Individualentwicklung, Unternehmenssoftware in Baukastenform.
      </h3>
    </div>

    <bd-main-section />
  </div>
</template>

<script>
  import BdMainSection from './sections/BdMainSection';

  export default {
    name: 'Home',
    bodyClass: 'home-page',
    components: {
      BdMainSection
    },
    data() {
      return {
        bgImage: require('@/assets/img/bg.jpg')
      }
    }
  }
</script>
